export function getScrollTop(element: Window|Element): number {
  if (element instanceof Window) {
    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
  }
  return element.scrollTop;
}

export function getVisibleHeight(element: Window|Element): number {
  if (element instanceof Window) {
    return document.documentElement.clientHeight;
  }
  return element.clientHeight;
}

export function getScrollableHeight(element: Window|Element): number {
  if (element instanceof Window) {
    return document.documentElement.offsetHeight;
  }
  return element.scrollHeight;
}

export function isAtBottom(element: Window|Element, distance: number = 0): boolean {
  const scrollPosition = getScrollTop(element) + getVisibleHeight(element);
  return ((getScrollableHeight(element) - scrollPosition) <= distance);
}
